import { unionBy } from 'lodash';
import {
  CAMPAIGNS_SUCCESS,
  CAMPAIGN_SUCCESS,
  CAMPAIGN_DELETE,
  CAMPAIGN_UPDATE,
} from '../constants/actions';

const initialState = {
  isFetching: false,
  hasFetched: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CAMPAIGNS_SUCCESS:
      return {
        ...state,
        data: action.data,
      };

    case CAMPAIGN_SUCCESS:
      return {
        ...state,
        data: unionBy([action.data], state.data, (c) => c.uuid),
      };

    case CAMPAIGN_DELETE:
      return {
        ...state,
        data: state.data.filter((c) => c.uuid !== action.uuid),
      };

    case CAMPAIGN_UPDATE:
      return {
        ...state,
        data: unionBy([action.data], state.data, (c) => c.uuid),
      };

    default:
      return { ...state };
  }
};
